import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        backgroundColor: 'white',
        padding: theme.spacing(0),
        borderRadius: theme.shape.borderRadius,
        width: '80%',
        maxWidth: '800px',
        maxHeight: '90%',
        overflowY: 'auto',
    },
    modalTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: "18px !important",
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        color: theme.palette.info.main,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        padding: theme.spacing(4, 5)
    },
    userNameContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        color: theme.palette.primary.darker,
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        paddingLeft: 10,
        paddingTop: 15
    },
    userImage: {
        borderRadius: "50%",
        width: "22px",
        height: "22px",
        objectFit: 'cover'
    },
    percentageDetail: {
        padding: '15px',
        textAlign: "left",
        verticalAlign: "middle",
        color: theme.palette.info.main,
        fontSize: 14,
        fontWeight: 700,
        fontFamily: "Source Sans 3"
    },
    descriptionWrapper: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        color: theme.palette.info.main,
        fontWeight: 600,
    },
    modalBody: {
        background: theme.palette.backgrounds.main
    }
}));